/* TIMESTAMP START 2026-08-22T13:31:48-04:00 | REVISION R000230 */
  /* TIMESTAMP START 2026-08-21T16:26:00-04:00 | REVISION R000186 */
  (() => {
    /* TIMESTAMP START 2026-08-21T17:26:50-04:00 | REVISION R000194 */
    const selector = [
      ".ymq-options-box[data-name='properties[Packing]']",
      ".ymq-options-box[data-name='properties[Packing:]']",
    ].join(', ');
    /* TIMESTAMP END 2026-08-21T17:26:50-04:00 | REVISION R000194 */

    const makeDot = () => {
      const dot = document.createElement('span');
      dot.className = 'jpi-packaging-choice__dot';
      return dot;
    };

    const makeIcon = (kind) => {
      const icon = document.createElement('span');
      icon.className = 'jpi-packaging-choice__icon';
      icon.setAttribute('aria-hidden', 'true');

      if (kind === 'bulk') {
        const ring = document.createElement('span');
        ring.className = 'jpi-packaging-choice__bulk-ring';
        ring.append(makeDot(), makeDot(), makeDot());
        icon.append(ring);
        return icon;
      }

      const rings = document.createElement('span');
      rings.className = 'jpi-packaging-choice__individual-rings';
      for (let index = 0; index < 3; index += 1) {
        const ring = document.createElement('span');
        ring.className = 'jpi-packaging-choice__unit-ring';
        ring.append(makeDot());
        rings.append(ring);
      }
      icon.append(rings);
      return icon;
    };

    const enhancePackingChoice = (box, index) => {
      if (box.dataset.jpiPackagingCards === 'ready') return;

      const select = box.querySelector('select.ymq-dropdown');
      if (!select) return;

      const optionByKind = ['bulk', 'individual'].map((kind) => ({
        kind,
        option: [...select.options].find((option) => option.value.trim().toLowerCase() === kind),
      }));
      if (optionByKind.some(({ option }) => !option)) return;

      box.dataset.jpiPackagingCards = 'ready';
      select.classList.add('jpi-packaging-choice__native');
      select.setAttribute('aria-hidden', 'true');
      select.tabIndex = -1;

      const fieldset = document.createElement('fieldset');
      fieldset.className = 'jpi-packaging-choice';

      const legend = document.createElement('legend');
      legend.className = 'jpi-packaging-choice__legend';
      const legendText = document.createElement('span');
      legendText.textContent = 'Packing';
      const requiredText = document.createElement('span');
      requiredText.className = 'jpi-packaging-choice__required';
      requiredText.textContent = 'Required';
      legend.append(legendText, requiredText);

      const hint = document.createElement('p');
      hint.className = 'jpi-packaging-choice__hint';
      hint.id = `jpi-packaging-hint-${index}`;
      hint.textContent = 'Choose how multiple units should be packed.';

      const cards = document.createElement('div');
      cards.className = 'jpi-packaging-choice__cards';
      const radios = [];

      optionByKind.forEach(({ kind, option }) => {
        const card = document.createElement('label');
        card.className = 'jpi-packaging-choice__card';

        const radio = document.createElement('input');
        radio.className = 'jpi-packaging-choice__input';
        radio.type = 'radio';
        radio.name = `jpi-packaging-${index}`;
        radio.value = option.value;
        radio.required = true;
        radio.setAttribute('aria-describedby', hint.id);

        const copy = document.createElement('span');
        copy.className = 'jpi-packaging-choice__copy';
        const name = document.createElement('span');
        name.className = 'jpi-packaging-choice__name';
        name.textContent = kind === 'bulk' ? 'Bulk' : 'Individual';
        const description = document.createElement('span');
        description.className = 'jpi-packaging-choice__description';
        description.textContent = kind === 'bulk' ? 'Packed together' : 'Packed separately';
        copy.append(name, description);

        const status = document.createElement('span');
        status.className = 'jpi-packaging-choice__status';
        status.setAttribute('aria-hidden', 'true');

        radio.addEventListener('change', () => {
          if (!radio.checked) return;
          select.value = radio.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
          syncSelection();
        });

        card.append(radio, makeIcon(kind), copy, status);
        cards.append(card);
        radios.push({ card, radio });
      });

      const syncSelection = () => {
        radios.forEach(({ card, radio }) => {
          radio.checked = select.value === radio.value;
          card.dataset.selected = String(radio.checked);
        });
      };

      select.addEventListener('input', syncSelection);
      select.addEventListener('change', syncSelection);
      fieldset.append(legend, hint, cards);
      box.insertBefore(fieldset, select);
      syncSelection();
    };

    const enhanceAll = () => {
      document.querySelectorAll(selector).forEach(enhancePackingChoice);
    };

    enhanceAll();
    new MutationObserver(enhanceAll).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  })();
  /* TIMESTAMP END 2026-08-21T16:26:00-04:00 | REVISION R000186 */
/* TIMESTAMP END 2026-08-22T13:31:48-04:00 | REVISION R000230 */
